export default __webpack_public_path__ + "static/cafe_36087-a9ef4a08cd5b952592d66cc80a5f1f61.png";